<template>
    <b-container fluid class="m-lg-4 m-0 p-0">
        <b-card class="h-100 command-centre-card m-0">
          <div slot="header">Command Centre
            <div class="card-header-actions d-lg-none d-md-inline d-sm-inline">
              <i class="icon-menu" v-b-modal.mobileModal></i>
            </div>
          </div>
          <b-row class="flex-grow-1 p-0 px-lg-3 pt-lg-3">
            <b-col sm="12" md="12" lg="8" xl="8">
              <site-map :displayTrackers="displayTrackers" :displayMapped="displayMapped" :displayKey="displayKey" @selectedTrackers="handleSelectedTrackers"
                :angle="selectedSite ? selectedSite.angle : 0" :readyToLoad="selectedGCU !== null">
              </site-map>
            </b-col>
            <b-col sm="12" md="12" lg="4" xl="4" class="d-none d-lg-flex flex-lg-column">
              <command-centre-actions :gcuChoices="gcuChoices" :selectedSite="selectedSite" class="flex-grow-1"
                v-model="selectedGCU" @commandClick="handleCommandClick">
              </command-centre-actions>
            </b-col>
          </b-row>
          <b-row class="d-none d-lg-flex flex-lg-column px-3 pb-3">
            <command-centre-console class="mx-3" :consoleOutput="consoleOutput"></command-centre-console>
          </b-row>
        </b-card>
        <b-modal id="mobileModal" hide-footer class="mobile-modal">
          <command-centre-actions :gcuChoices="gcuChoices" :selectedSite="selectedSite" class="flex-grow-1"
            v-model="selectedGCU" @commandClick="handleCommandClick">
          </command-centre-actions>
          <command-centre-console :consoleOutput="consoleOutput"></command-centre-console>
        </b-modal>
    </b-container>
</template>

<script>
import CommandCentreConsole from '../components/CommandCentreConsole';
import CommandCentreActions from '../components/CommandCentreActions';
import SiteMap from '../components/leaflet/SiteMap';
import { mapGetters } from 'vuex';

let subscription = null;

export default {
  name: 'commandcentre',
  components: {
    CommandCentreConsole,
    CommandCentreActions,
    SiteMap
  },
  data() {
    return {
      selectedGCU: null,
      selectedTrackers: null,
      consoleOutput: []
    };
  },
  methods: {
    handleSelectedTrackers(selectedTrackers) {
      this.selectedTrackers = selectedTrackers;
      console.log(selectedTrackers);
      if (selectedTrackers) console.log(Object.keys(selectedTrackers).length);
    },
    handleCommandClick(command) {
      const commandCode = command.code;

      if (!this.selectedGCU) return;

      if (command.no_tracker === 'Y') {
        if (!this.selectedTrackers) {
          this.writeToCommandConsole('info', `A tracker selection is required for ${command.short_description} command.`);
          return;
        }

        const selectedTrackers = Object.values(this.selectedTrackers);

        if (command.tracker === '0') {
          this.sendLCUCommands(command, selectedTrackers);
        }

        else if (command.tracker === '1') {
          this.displayGCUs.forEach((gcuId) => {
            const selectedGCUTrackers = this.getSelectedGCUTrackers(gcuId);

            if (this.gcuTrackers(gcuId).length === selectedGCUTrackers.length) {
              this.$broker.sendAllLCUCommand(commandCode, this.$broker.commandCentreReplyQueue);
              this.writeToCommandConsole('send', `${command.short_description}`);
            } else {
              this.sendLCUCommands(command, selectedGCUTrackers);
            }
          });
        }
      }

      else if (command.tracker === '0' && command.no_tracker === 'N') {
        this.$broker.sendGCUCommand(commandCode, this.selectedGCU.id, this.$broker.commandCentreReplyQueue);
        this.writeToCommandConsole('send', `${command.short_description}`);
      }
    },
    sendLCUCommands(command, selectedTrackers) {
      selectedTrackers.forEach((tracker) => {
        this.$broker.sendLCUCommand(command.code, tracker.gcu_code, tracker.lcu_code.toString(), this.$broker.commandCentreReplyQueue);
        this.writeToCommandConsole('send', `${command.short_description}`);
      });
    },
    getSelectedGCUTrackers(gcuId) {
      const selectedTrackers = Object.values(this.selectedTrackers);
      return selectedTrackers.filter((tracker) => tracker.gcu_code === gcuId);
    },
    writeToCommandConsole(type, message) {
      switch(type) {
        case 'info':
          this.consoleOutput.push({ icon: 'icon-info', iconColor: '#31708f', message, backgroundColor: '#d9edf7', borderColor: '#bce8f1' });
          break;
        case 'send':
          this.consoleOutput.push({ icon: 'icon-arrow-up-circle', iconColor: '#333', message, backgroundColor: null, borderColor: '#e1e1e8' });
          break;
        case 'reply':
          this.consoleOutput.push({ icon: 'icon-arrow-down-circle', iconColor: '#333', message, backgroundColor: null, borderColor: '#e1e1e8' });
          break;
      }
    }
  },
  computed: {
    ...mapGetters('savanna/subarrays', {
      mappedSubarrays: 'getMappedSubarrays'
    }),
    ...mapGetters('savanna/subarrays', {
      unmappedSubarrays: 'getUnmappedSubarrays'
    }),
    ...mapGetters('savanna/gcus', {
      gcuNames: 'getGCUNames'
    }),
    ...mapGetters('savanna/trackers', {
      gcuTrackers: 'getTrackerNames'
    }),
    ...mapGetters('savanna/sites', {
      selectedSite: 'getSelectedSite'
    }),
    gcuChoices() {
      const choices = [];

      if (this.selectedSite) {
        const mappedSubarrays = this.mappedSubarrays(this.selectedSite.id);
        const unmappedSubarrays = this.unmappedSubarrays(this.selectedSite.id);
        const gcuNames = this.gcuNames(this.selectedSite.id);

        if (mappedSubarrays && unmappedSubarrays) {
          const gcus = {};
          gcuNames.forEach((gcu) => {
            Object.assign(gcus, { [gcu.id] : gcu.name });
          });

          Object.keys(mappedSubarrays).forEach((subarrayId) => {
            const gcuId = mappedSubarrays[subarrayId][0].gcu_code;
            const found = choices.find((gcu) => gcu.id === gcuId);
            if (!found) {
              if (gcus[gcuId]) {
                choices.push({ id: gcuId, mapped: true, name: gcus[gcuId], siteId: this.selectedSite.id });
              } else {
                choices.push({ id: gcuId, mapped: true, name: gcuId, siteId: this.selectedSite.id });
              }
            }
          });

          Object.keys(unmappedSubarrays).forEach((gcuId) => {
            if (unmappedSubarrays[gcuId].length === 0) {
              if (gcus[gcuId]) {
                choices.push({ id: gcuId, mapped: false, name: gcus[gcuId], siteId: this.selectedSite.id });
              } else {
                choices.push({ id: gcuId, mapped: false, name: gcuId, siteId: this.selectedSite.id });
              }
            } else {
              if (gcus[gcuId]) {
                choices.push({ id: gcuId, mapped: false, name: gcus[gcuId] + ' (Unscanned)', siteId: this.selectedSite.id });
              } else {
                choices.push({ id: gcuId, mapped: false, name: gcuId + ' (Unscanned)', siteId: this.selectedSite.id });
              }
            }
          });
        }
      }

      return choices;
    },
    displayGCUs() {
      const displayGCUs = [];

      if (this.selectedGCU) {
        if (this.displayMapped) {
          this.gcuChoices.forEach((gcuChoice) => {
            displayGCUs.push(gcuChoice.id);
          });
        } else {
          displayGCUs.push(this.selectedGCU.id);
        }
      }

      return displayGCUs;
    },
    siteSubarrays() {
      let displaySubarrays = null;
      if (this.selectedSite !== null && this.selectedGCU !== null) {
        if (this.selectedGCU.mapped) {
          displaySubarrays = this.mappedSubarrays(this.selectedSite.id);
        } else if (!this.selectedGCU.mapped) {
          displaySubarrays = this.unmappedSubarrays(this.selectedSite.id) ? this.unmappedSubarrays(this.selectedSite.id)[this.selectedGCU.id] : null;
        }
      }
      return displaySubarrays;
    },
    displayKey() {
      if (this.selectedSite !== null && this.selectedGCU !== null) {
        return `${this.selectedSite.id}:${this.selectedGCU.mapped ? 'mapped' : this.selectedGCU.id}`;
      }

      return '';
    },
    displayMapped() {
      if (this.selectedGCU) {
        return this.selectedGCU.mapped;
      }
      return true;
    },
    displayTrackers() {
      return this.siteSubarrays;
    }
  },
  created() {
    // Create a new reply queue if one doesn't exist
    if (!this.$broker.commandCentreReplyQueue) {
        this.$broker.commandCentreReplyQueue = this.$broker.genUserQueueName();;
    }

    this.$broker.subscribe(this.$broker.commandCentreReplyQueue, (msg) => {
      msg.ack();
      this.writeToCommandConsole('reply', msg.body);
    }).then(sub => subscription = sub);
  },
  beforeDestroy() {
    if (subscription) {
      subscription.unsubscribe();
    }
  },
};
</script>

<style scoped>
.command-centre-card .card-body {
  display: flex;
  flex-direction: column;
  padding: 0;
}
</style>

<style <style lang="scss">

@import '~leaflet/dist/leaflet.css';

.mobile-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
}

.mobile-modal .modal-body {
  display: flex;
  flex-direction: column;
}
</style>
